import Phaser from 'phaser';
import { TutorialStep } from './types/alice-bob';
import applyResponsiveScaling from './utils/applyResponsiveScaling';
import enforceOrientation from './utils/enforceOrientation';
import P34TOptions from './config/p34t.options';
import gameConfig from './config/gameConfig';
import Boot from './app/scenes/boot/Boot';
import Preload from './app/scenes/preload/Preload';
import Game from './app/scenes/game/Game';
import Lazyloader from './app/scenes/lazyloader/Lazyloader';
import * as Sentry from "@sentry/browser";
import { coldStart, setTutorialStep } from './app/backend/store/tutorial';
import { getAuthTokenPlusProfile } from './app/backend/api/auth';

export const applicationVersion = import.meta.env.VITE_APP_VERSION_GIT;

Sentry.init({
    dsn: "https://90848cc2312ac5cfa72c216b9765999c@o4507378757861376.ingest.de.sentry.io/4509629282451536",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
});

function waitForTelegramSDK(): Promise<void> {
    return new Promise((resolve) => {
        const interval = setInterval(() => {
            if (window.Telegram) {
                clearInterval(interval);
                resolve();
            }
        }, 100);
    });
}

const supportedLocales = ['en', 'ru', 'de', 'fr', 'it', 'jp', 'uk']
const defaultLocale = 'en'

document.addEventListener('DOMContentLoaded', async () => {
    console.log(`DOMContentLoaded, application version :${applicationVersion}`)
    //Dev2Dev analytics
    window.devtodev.initialize('fd980aad-efc8-0317-8be3-395b036e880f', { applicationVersion });
    window.devtodev.tutorial(coldStart());
    setTutorialStep(TutorialStep.INIT);

    await waitForTelegramSDK();
    const webAppVersion = parseInt(window.Telegram.WebApp.version);
    let playerLocale = 'en';
    if (webAppVersion >= 8) {
        getAuthTokenPlusProfile() // Request is as earlier as possible to save loading time for new comer player.
        window.devtodev.customEvent("game_play_started", { "stage": 1 })
        // window.Telegram.WebApp.onEvent('viewportChanged', phaserInit)
        window.Telegram.WebApp.requestFullscreen();
        window.Telegram.WebApp.enableClosingConfirmation();
        window.Telegram.WebApp.disableVerticalSwipes();
        window.Telegram.WebApp.SettingsButton.show();

        // console.log('Telegram incoming locale: ' + window.Telegram.WebApp.initDataUnsafe.user?.language_code)
        playerLocale = window.Telegram.WebApp.initDataUnsafe.user?.language_code || playerLocale;
        if (supportedLocales.indexOf(playerLocale) == -1) playerLocale = defaultLocale;
    }

    await new Promise(resolve => setTimeout(resolve, 1000));
    window.devtodev.customEvent("game_play_started", { "stage": 2 })
    phaserInit(playerLocale)
});

function phaserInit(playerLocale: string) {
    window.devtodev.customEvent("game_play_started", { "stage": 3 })
    applyResponsiveScaling(gameConfig);
    enforceOrientation();
    if (P34TOptions.title) document.title = P34TOptions.title;

    gameConfig.scene = [Boot, Preload, Game, Lazyloader];
    new Phaser.Game({
        ...gameConfig, callbacks: {
            preBoot: function (game: any) {
                game.registry.merge({ playerLocale });
            }
        }
    });
}

